import React, { createContext, useContext, useEffect } from 'react';
import useAuth from '@/hooks/stores/useAuth';
import { heartbeatService } from '@/services/heartbeatService';

const HeartbeatContext = createContext(null);

export const HeartbeatProvider = ({ children }) => {
  const { userRole } = useAuth();

  useEffect(() => {
    // Start heartbeat if user role is 'user'
    if (userRole && userRole.toLowerCase() === 'user') {
    //   console.log('Starting heartbeat from context...');
      heartbeatService.startHeartbeat();
    }

    // Cleanup function to stop heartbeat when component unmounts
    return () => {
    //   console.log('Cleaning up heartbeat...');
      heartbeatService.stopHeartbeat();
    };
  }, [userRole]); // Only re-run if userRole changes

  return (
    <HeartbeatContext.Provider value={null}>
      {children}
    </HeartbeatContext.Provider>
  );
};

export const useHeartbeat = () => {
  const context = useContext(HeartbeatContext);
  if (context === undefined) {
    throw new Error('useHeartbeat must be used within a HeartbeatProvider');
  }
  return context;
}; 